import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./SideNavbar.css";

export default function SideNavbar() {
  const location = useLocation();
  const [openDropdowns, setOpenDropdowns] = useState({
    customize: false,
    registration: false,
    reviewer: false,
    venue: false,
    paper: false,
    schedule: false,
  });

  // Function to check if current path matches the link
  const isActive = (path) => {
    return location.pathname === path;
  };

  // Function to check if any dropdown item is active
  const isDropdownActive = (paths) => {
    return paths.some((path) => location.pathname === path);
  };

  const toggleDropdown = (dropdownName) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [dropdownName]: !prev[dropdownName],
    }));
  };

  return (
    <div className="sidebar">
      {/* Admin Dashboard Link */}
      <section>
        <Link
          className={`sidebar-item ${
            isActive("/admin/dashboard") ? "active" : ""
          }`}
          to="/admin/dashboard"
        >
          <div className="sidebar-title">
            <span>
              <i className="bi bi-speedometer2"></i>
              Admin Dashboard
            </span>
          </div>
        </Link>
      </section>
      {/* Customize Page Dropdown */}
      <section>
        <div
          className={`sidebar-item ${openDropdowns.customize ? "open" : ""} ${
            isDropdownActive([
              "/admin/manage-committee",
              "/admin/update-committee",
              "/admin/remove-committee",
              "/admin/speaker",
              "/admin/remove/speaker",
              "/admin/customize-homepage",
              "/admin/customize-date",
              "/admin/customize-submission",
            ])
              ? "dropdown-active"
              : ""
          }`}
        >
          <div
            className="sidebar-title"
            onClick={() => toggleDropdown("customize")}
          >
            <span>
              <i className="bi bi-gear-fill"></i>
              Customize Page
            </span>
            <i className="bi-chevron-down toggle-btn"></i>
          </div>
          <div className="sidebar-content">
            <Link
              className={`dropdown-item ${
                isActive("/admin/manage-committee") ? "active" : ""
              }`}
              to="/admin/manage-committee"
            >
              Add Committee
            </Link>
            <Link
              className={`dropdown-item ${
                isActive("/admin/update-committee") ? "active" : ""
              }`}
              to="/admin/update-committee"
            >
              Update Committee
            </Link>
            <Link
              className={`dropdown-item ${
                isActive("/admin/remove-committee") ? "active" : ""
              }`}
              to="/admin/remove-committee"
            >
              Remove Committee
            </Link>
            <Link
              className={`dropdown-item ${
                isActive("/admin/speaker") ? "active" : ""
              }`}
              to="/admin/speaker"
            >
              Add Speaker
            </Link>
            <Link
              className={`dropdown-item ${
                isActive("/admin/remove/speaker") ? "active" : ""
              }`}
              to="/admin/remove/speaker"
            >
              Remove Speaker
            </Link>
            <Link
              className={`dropdown-item ${
                isActive("/admin/customize-homepage") ? "active" : ""
              }`}
              to="/admin/customize-homepage"
            >
              Customize HomePage
            </Link>
            <Link
              className={`dropdown-item ${
                isActive("/admin/customize-date") ? "active" : ""
              }`}
              to="/admin/customize-date"
            >
              Customize Date
            </Link>
            <Link
              className={`dropdown-item ${
                isActive("/admin/customize-submission") ? "active" : ""
              }`}
              to="/admin/customize-submission"
            >
              Customize Submission
            </Link>
          </div>
        </div>
      </section>

      {/* Registration Dropdown */}
      <section>
        <div
          className={`sidebar-item ${
            openDropdowns.registration ? "open" : ""
          } ${
            isDropdownActive([
              "/admin/registration-fees",
              "/admin/registration-process",
            ])
              ? "dropdown-active"
              : ""
          }`}
        >
          <div
            className="sidebar-title"
            onClick={() => toggleDropdown("registration")}
          >
            <span>
              <i className="bi bi-card-checklist"></i>
              Registration
            </span>
            <i className="bi-chevron-down toggle-btn"></i>
          </div>
          <div className="sidebar-content">
            <Link
              className={`dropdown-item ${
                isActive("/admin/registration-fees") ? "active" : ""
              }`}
              to="/admin/registration-fees"
            >
              Registration Fees
            </Link>
            <Link
              className={`dropdown-item ${
                isActive("/admin/registration-process") ? "active" : ""
              }`}
              to="/admin/registration-process"
            >
              Registration Process
            </Link>
          </div>
        </div>
      </section>

      {/* Reviewer Info Dropdown */}
      <section>
        <div
          className={`sidebar-item ${openDropdowns.reviewer ? "open" : ""} ${
            isDropdownActive([
              "/admin/add-reviewer-manually",
              "/admin/accept-reviewer",
              "/admin/request-reviewer",
              "/admin/reviewer-list",
            ])
              ? "dropdown-active"
              : ""
          }`}
        >
          <div
            className="sidebar-title"
            onClick={() => toggleDropdown("reviewer")}
          >
            <span>
              <i className="bi bi-person-check"></i>
              Reviewer Info
            </span>
            <i className="bi-chevron-down toggle-btn"></i>
          </div>
          <div className="sidebar-content">
            <Link
              className={`dropdown-item ${
                isActive("/admin/add-reviewer-manually") ? "active" : ""
              }`}
              to="/admin/add-reviewer-manually"
            >
              Add Reviewer Manually
            </Link>
            <Link
              className={`dropdown-item ${
                isActive("/admin/accept-reviewer") ? "active" : ""
              }`}
              to="/admin/accept-reviewer"
            >
              Pending Reviewer
            </Link>
            <Link
              className={`dropdown-item ${
                isActive("/admin/request-reviewer") ? "active" : ""
              }`}
              to="/admin/request-reviewer"
            >
              Requested Reviewer
            </Link>
            <Link
              className={`dropdown-item ${
                isActive("/admin/reviewer-list") ? "active" : ""
              }`}
              to="/admin/reviewer-list"
            >
              Users List
            </Link>
          </div>
        </div>
      </section>

      {/* Venue Dropdown */}
      <section>
        <div
          className={`sidebar-item ${openDropdowns.venue ? "open" : ""} ${
            isDropdownActive([
              "/admin/add-venue",
              "/admin/remove-venue",
              "/admin/add-accomodation",
              "/admin/remove-accomodation",
              "/admin/add-tourist",
              "/admin/remove-tourist",
            ])
              ? "dropdown-active"
              : ""
          }`}
        >
          <div
            className="sidebar-title"
            onClick={() => toggleDropdown("venue")}
          >
            <span>
              <i className="bi bi-geo-alt-fill"></i>
              Venue
            </span>
            <i className="bi-chevron-down toggle-btn"></i>
          </div>
          <div className="sidebar-content">
            <Link
              className={`dropdown-item ${
                isActive("/admin/add-venue") ? "active" : ""
              }`}
              to="/admin/add-venue"
            >
              Add Venue
            </Link>
            <Link
              className={`dropdown-item ${
                isActive("/admin/remove-venue") ? "active" : ""
              }`}
              to="/admin/remove-venue"
            >
              Remove Venue
            </Link>
            <Link
              className={`dropdown-item ${
                isActive("/admin/add-accomodation") ? "active" : ""
              }`}
              to="/admin/add-accomodation"
            >
              Add Accomodation
            </Link>
            <Link
              className={`dropdown-item ${
                isActive("/admin/remove-accomodation") ? "active" : ""
              }`}
              to="/admin/remove-accomodation"
            >
              Remove Accomodation
            </Link>
            <Link
              className={`dropdown-item ${
                isActive("/admin/add-tourist") ? "active" : ""
              }`}
              to="/admin/add-tourist"
            >
              Add Tourist Place
            </Link>
            <Link
              className={`dropdown-item ${
                isActive("/admin/remove-tourist") ? "active" : ""
              }`}
              to="/admin/remove-tourist"
            >
              Remove Tourist Place
            </Link>
          </div>
        </div>
      </section>
      {/* Paper Dropdown */}
      <section>
        <div
          className={`sidebar-item ${openDropdowns.paper ? "open" : ""} ${
            isDropdownActive([
              "/admin/customize-submission-domain",
              "/admin/customize-paper",
              "/admin/manually-add-paper",
              "/admin/print-paper-summary",
              "/admin/send-email",
            ])
              ? "dropdown-active"
              : ""
          }`}
        >
          <div
            className="sidebar-title"
            onClick={() => toggleDropdown("paper")}
          >
            <span>
              <i className="bi bi-file-earmark-text"></i>
              Paper
            </span>
            <i className="bi-chevron-down toggle-btn"></i>
          </div>
          <div className="sidebar-content">
            <Link
              className={`dropdown-item ${
                isActive("/admin/customize-submission-domain") ? "active" : ""
              }`}
              to="/admin/customize-submission-domain"
            >
              Customize Domain
            </Link>
            <Link
              className={`dropdown-item ${
                isActive("/admin/customize-paper") ? "active" : ""
              }`}
              to="/admin/customize-paper"
            >
              Customize Paper
            </Link>
            <Link
              className={`dropdown-item ${
                isActive("/admin/manually-add-paper") ? "active" : ""
              }`}
              to="/admin/manually-add-paper"
            >
              Manually Add Paper
            </Link>
            <Link
              className={`dropdown-item ${
                isActive("/admin/print-paper-summary") ? "active" : ""
              }`}
              to="/admin/print-paper-summary"
            >
              Print Paper Summary
            </Link>
            <Link
              className={`dropdown-item ${
                isActive("/admin/send-email") ? "active" : ""
              }`}
              to="/admin/send-email"
            >
              Send Email
            </Link>
          </div>
        </div>
      </section>

      {/* Pre-Schedule Dropdown */}
      <section>
        <div
          className={`sidebar-item ${openDropdowns.schedule ? "open" : ""} ${
            isDropdownActive(["/admin/add-schedule", "/admin/remove-schedule"])
              ? "dropdown-active"
              : ""
          }`}
        >
          <div
            className="sidebar-title"
            onClick={() => toggleDropdown("schedule")}
          >
            <span>
              <i className="bi bi-calendar-event"></i>
              Pre-Schedule
            </span>
            <i className="bi-chevron-down toggle-btn"></i>
          </div>
          <div className="sidebar-content">
            <Link
              className={`dropdown-item ${
                isActive("/admin/add-schedule") ? "active" : ""
              }`}
              to="/admin/add-schedule"
            >
              Add Schedule
            </Link>
            <Link
              className={`dropdown-item ${
                isActive("/admin/remove-schedule") ? "active" : ""
              }`}
              to="/admin/remove-schedule"
            >
              Remove Schedule
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
